import { render, staticRenderFns } from "./TopRoutes.vue?vue&type=template&id=8af970fc"
import script from "./TopRoutes.vue?vue&type=script&lang=js"
export * from "./TopRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports